* {
  box-sizing: border-box;
}

:host {
  display: flex;
  gap: $xp-ref-spacing-2;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @include mobile {
    flex-direction: column;
  }

  @include tablet {
    flex-direction: column;
  }

  @include desktop {
    flex-direction: column;
  }
}

.header {
  position: relative;
  width: 100%;
  align-items: center;

  @include mobile {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
  @include tablet {
    display: flex;
    flex-direction: row;
  }
  @include desktop {
    display: flex;
    flex-direction: row;
  }
}

.symbol {
  display: flex;
  position: relative;
  border-radius: 50%;
  flex-shrink: 0;
  @include mobile {
    width: 20px;
    height: 20px;
  }
  @include tablet {
    width: 20px;
    height: 20px;
  }
  @include desktop {
    width: 20px;
    height: 20px;
  }
  &.todo {
    border: 1px solid $xp-ref-color-border-heavy;
    background-color: inherit;
  }
  &.current {
    background-color: $xp-ref-color-state-select;
    .inner-circle {
      background-color: $xp-ref-color-border-focus-default;
      width: 50%;
      height: 50%;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &.done {
    background-color: $xp-ref-color-semantic-success-low-emphasis;
    .check-sym {
      color: $xp-ref-color-semantic-on-success;
    }
  }
  &.cancelled {
    background-color: $xp-ref-color-semantic-critical-high-emphasis;
    .close-sym {
      color: $xp-ref-color-semantic-on-critical;
    }
  }
  &.error {
    background-color: $xp-ref-color-semantic-critical-high-emphasis;
    .error-sym {
      color: $xp-ref-color-semantic-on-critical;
    }
  }
  .material-icons-sharp {
    font-size: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .material-icons-outlined {
    font-size: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.body {
  display: flex;
  flex-direction: column;
}

.footer {
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
  height: 32px;

  &.download-button-desktop {
    height: 44px;
  }

  &.download-button-mobile {
    padding-left: 20px;
    height: 44px;
  }
}

.bar {
  display: flex;
  border: 1px solid $xp-ref-color-border-medium;

  @include mobile {
    position: relative;
    left: 10px;
  }

  @include tablet {
    height: 0;
    left: 0;
    width: 100%;
  }
  @include desktop {
    width: 100%;
  }
}
.step {
  font: $xp-ref-font-headline-headline06;
  color: $xp-ref-color-text-default-dark;
}

.details {
  font: $xp-ref-font-paragraph-paragraph-small;
  color: $xp-ref-color-text-default-medium;
}

.download {
  font-size: 20px;
  width: 20px;
  color: $xp-ref-color-semantic-on-interaction;
}
